import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take, filter, switchMap } from 'rxjs/operators';
import { Auth } from '@angular/fire/auth';
import { UserService } from '../user/user.service';

export const authGuard: CanActivateFn = (route, state) => {
   const router = inject(Router);
   const userService = inject(UserService);
   const auth = inject(Auth);

   return userService.isInitialized$.pipe(
      filter((initialized) => initialized === true),
      take(1),
      switchMap(() => userService.currentUser$),
      take(1),
      map((user) => {
         if (user) {
            return true;
         }
         // Fallback: Firebase Auth session is still valid but Firestore user doc
         // hasn't loaded yet (e.g. slow network after mobile browser resumes).
         // Allow access — the doc will arrive shortly via the BehaviorSubject.
         if (auth.currentUser) {
            return true;
         }
         console.warn('[AuthGuard] No user found, redirecting to /login');
         router.navigate(['/login']);
         return false;
      }),
   );
};
